import ResultPage from '@/components/Result/index';
import { assetUrl } from '@/utils/asset-url';

const RecordTransferShareSuccessPage = () => {

	const breadcrumbsItem = [
		{
			label: '',
			link: '/'
		 },
		{
			label: 'E-Transferable Record',
			link: '/record-transfer'
		},
		{
			label: `Issue New ETR`,
			link:''
		}
	]
	return ResultPage({
		defaultTitle: "shareData",
		layoutHeaderTxt: "Issuance in Progress.",
		layoutSubHeaderTxt: "You can keep track of the newly issued ETR stored on the ETR List Tab.",
		layoutContentImgPath: assetUrl("/img/theme-success.png"),
		backBtnTxt: "Done",
		breadcrumbs: breadcrumbsItem,
		viewRecordLocation: '/record-transfer',
		nextLocation: '/record-transfer',
        translationCheck: false,
        viewETRRecord: true
	});
}

export default RecordTransferShareSuccessPage
